import React, { Component } from 'react';
import whiteLogo from '../../assets/landing/pilotly-logo-white.png';
import DeviceHelper from '../../functions/device';

export default class GlobalHeader extends Component {
	render() {
		return (
			<header className="landing-header z-depth-0">
				<nav className="landing-header-container-web z-depth-0">
					<div className={'logo-container' + (DeviceHelper.isMobile ? 'landing-header-btn-container-mobile' : 'landing-header-btn-container')}>
						<a href='/' className="landing-landing-header-logo-link">
							<img className="landing-header-logo noselect" src={whiteLogo} alt='Pilotly' />
						</a>
					</div>
				</nav>
			</header>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/global/GlobalHeader.js